<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="admin" class="flex flex-col">
        <div class="card">
          <div class="flex justify-between items-center">
            <p class="font-medium">ID: #{{ admin.id }}</p>

            <div class="flex space-x-4 items-center">
              <router-link
                v-if="hasPermission('edit_admins')"
                :to="{
                  name: 'adminsEditForm',
                  params: { id: admin.id },
                }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_admins')"
                @click.prevent="openDeleteModal()"
              />
            </div>

            <!-- <options-menu
              v-if="getOptions().length > 0"
              :options="getOptions()"
              @edit="
                $store.commit('pushRouteToBreadcrumbs', {
                  route: $route.name,
                  params: $route.params,
                  display_name: admin.name + ' ' + admin.last_name,
                });
                $router.push({
                  name: 'adminsEditForm',
                  params: { id: admin.id },
                });
              "
              @delete="openDeleteModal()"
            /> -->
          </div>

          <div class="div-line"></div>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 text-sm mt-2"
          >
            <div class="text-sm">
              <p class="font-medium">Nombre</p>
              <p>{{ admin.name }} {{ admin.last_name }}</p>
            </div>

            <div class="text-sm">
              <p class="font-medium">Rol</p>
              <p>{{ admin.is_super ? "Super Admin" : admin.user.role.name }}</p>
            </div>

            <div>
              <p class="font-medium">Correo</p>
              <p>{{ admin.user.email }}</p>
            </div>

            <div>
              <p class="font-medium">Fecha de creación</p>
              <p>{{ formatDatetime(admin.created_at) }}</p>
            </div>

            <div>
              <p class="font-medium">Fecha de última actualización</p>
              <p>{{ formatDatetime(admin.updated_at) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import Diet from "@/components/models/Diet";
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Admin Detail",

  components: {
    Diet,
  },

  data() {
    return {
      deliveryFrequencies: null,
      paymentFrequencies: null,
      admin: null,
      loading: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "admins");

    this.loadAdmin();
  },

  methods: {
    formatDatetime,

    async loadAdmin() {
      this.loading = true;

      try {
        this.admin = await api.admins.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: 'adminsDetail',
          label: this.admin.name + ' ' + this.admin.last_name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: 'adminsIndex' });
      }

      this.loading = false;
    },

    getOptions() {
      let options = [];

      if (this.hasPermission("edit_admins")) {
        options.push({
          action: "edit",
          label: "Editar",
        });
      }

      if (this.hasPermission("delete_admins")) {
        options.push({
          action: "delete",
          label: "Eliminar",
        });
      }

      return options;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.admins.delete(this.admin.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.$router.push({ name: 'adminsIndex' });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>